<template>
  <div>
    <v-card
      class="card_details_product"
      v-for="(item, index) in selectedProducts"
      :key="index"
      v-if="item.amount > 0"
    >
      <v-row>
        <v-col
          xl="9"
          lg="8"
          md="12"
          sm="12"
          xs="12"
          cols="12"
          class="p-0"
          align="center"
        >
          <div class="box_mobile_product-r">
            <v-col
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              cols="12"
              class="p-0"
            >
              <div v-if="!item.amountChanged" class="text-stock">
                <h6 class="shopPrimary--text font-weight-bold">
                  موجودی قابل خرید {{ item.maxAmount }} میباشد
                </h6>
              </div>
            </v-col>
            <v-col
              xl="2"
              lg="3"
              md="3"
              sm="12"
              xs="12"
              cols="12"
              class="p-0"
              align="center"
            >
              <div class="img_box_details_product" @click="goToDetails(item)">
                <img :src="item.pictureUrl" alt="" style="object-fit: fill" />
              </div>
            </v-col>

            <v-col xl="10" lg="9" md="9" sm="12" xs="12" cols="12" class="p-0">
              <div class="items_mobile_product-r">
                <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                  <div class="text_content_details_product">
                    <h5 class="mainFont--text text-right font-weight-bold">
                      {{ item.name }}
                    </h5>
                  </div>
                </v-col>

                <v-col
                  xl="12"
                  lg="12"
                  md="12"
                  xs="12"
                  sm="12"
                  cols="12"
                  v-if="item.publisherName"
                >
                  <div
                    class="d-flex justify-start align-center text_content_details_product"
                  >
                    <v-icon class="primary--text"
                      >mdi-storefront-outline</v-icon
                    >
                    <h5 class="font-weight-bold mainFont--text ml-2">ناشر :</h5>
                    <h5 class="font-weight-bold shopPrimary--text">
                      {{ item.publisherName ? item.publisherName : " - " }}
                    </h5>
                  </div>
                </v-col>
                <v-col
                  xl="12"
                  lg="12"
                  md="12"
                  xs="12"
                  sm="12"
                  cols="12"
                  v-if="item.condition"
                >
                  <div class="text_content_details_product">
                    <v-icon class="primary--text"
                      >mdi-truck-delivery-outline</v-icon
                    >
                    <h5 class="font-weight-bold shopPrimary--text">
                      {{ item.condition }}
                    </h5>
                  </div>
                </v-col>
              </div>
            </v-col>
          </div>
        </v-col>
        <v-col
          xl="3"
          lg="4"
          md="12"
          sm="12"
          xs="12"
          cols="12"
          class="p-0"
          align-self="end"
        >
          <div class="box_mobile_product-l">
            <v-col xl="12" lg="12" md="12" xs="6" sm="12" cols="12">
              <div class="price_box_details_product">
                <h5 class="black--text font-weight-bold">قیمت:</h5>
                <div v-if="item.specialPrice == item.price">
                  <h5
                    class="black--text font-weight-bold text-left fs-medium mb-0"
                  >
                    {{ Number(item.price).toLocaleString() }} تومان
                  </h5>
                </div>

                <div v-else>
                  <div class="d-flex justify-content-end">
                    <div
                      class="d-flex justify-center align-center text-center"
                      style="
                        border-radius: 10%;
                        background-color: #d62728 !important ;
                        width: 28px;
                        height: 28px;
                        font-size: 12px;
                        margin-left: 12px;
                      "
                    >
                      <span class="white--text text-center"
                        >{{ item.discountPercentage }}%</span
                      >
                    </div>
                    <del class="mainFont--text text-left fs-small mb-0">
                      {{ Number(item.price).toLocaleString() }} تومان
                    </del>
                  </div>
                  <h5
                    class="black--text font-weight-bold text-left fs-medium mb-0"
                  >
                    {{ Number(item.specialPrice).toLocaleString() }} تومان
                  </h5>
                </div>
              </div>
            </v-col>
            <div
              xl="12"
              lg="12"
              md="6"
              xs="6"
              sm="12"
              cols="12"
              class="align-self-center align-center justify-center w-100"
            >
              <!--product counter-->
              <ProductCounter
                :item="item"
                :index="index"
                :cart-id="cartId"
                usage="'cart'"
                class="w-100"
                @send-amount="handleAmount"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-col xl="6" lg="8" md="12" sm="12" xs="12" cols="12" class="px-0">
      <div class="footer_card_information">
        <v-col xl="6" lg="6" md="6" xs="6" sm="12" cols="12">
          <v-btn block class="green-mainBtn" @click="$router.push('/store')">
            ادامه‌ خرید در فروشگاه
          </v-btn>
        </v-col>
        <v-col xl="6" lg="6" md="6" xs="6" sm="12" cols="12">
          <v-btn block class="purple-mainBtn" @click="clearCart()">
            حذف تمام محصولات
          </v-btn>
        </v-col>
      </div>
    </v-col>
  </div>
</template>
<script>
import Axios from "axios";
import ProductCounter from "../../../../components/OnlineShop/ProductCounter";
import { mapState } from "vuex";
export default {
  name: "BoxesProduct",
  props: ["items", "checkoutCart"],
  components: { ProductCounter },
  data: () => ({
    cartId: "",
    cart: [],
    selectedProducts: [],
  }),

  methods: {
    handleAmount(event) {
      this.item.amountInCart = event;
    },
    goToDetails(item) {
      this.$router.push(
        `/productdetails/${item.name.replaceAll(" ", "-")}-${item.id}`
      );
    },
    checkout: async function () {
      await Axios.post(
        this.baseUrl + "/onlineShop/cart/checkout/" + this.cartId,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast.success(res.data.message);
          } else {
            this.toast.error("خطایی رخ داده است. مجددا امتحان کنید.");
          }
        })
        .catch((err) => {
          this.toast.error(err.response.data);
        });
    },
    decreaseQuantity(item, index) {
      if (item.amount > 1) {
        this.removeItem(item);
      }
      if (item.amount == 1) {
        this.items.splice(index, 1);
        this.removeItem(item);
      }
    },
    increaseQuantity(item) {
      item.amount++;

      this.addToCart(item);
    },
    removeItem: async function (item) {
      await Axios.post(
        this.baseUrl + "/onlineShop/cart/removeItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            let products1 = res.data.items;
            if (!products1.length) {
              localStorage.setItem("cart", []);
              this.clearCart();
            }
            this.toast(res.data.message, "success");
            if (item.amount != 1) {
              item.amount--;
            }
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    clearCart: async function () {
      await Axios.post(
        this.baseUrl + "/onlineShop/cart/clear/" + this.cartId,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.$store.dispatch("removeCartItems");
            this.toast(res.data.message, "success");
            localStorage.setItem("cart", []);
            this.selectedProducts = [];
            setTimeout(() => {
              this.$router.push("/");
            }, 500);
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast.error(err.response.data);
        });
    },
    addToCart: async function (item) {
      await Axios.post(
        this.baseUrl + "/onlineShop/cart/addItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast.error(err.response.data);
        });
    },
    updateCart(val) {
      this.selectedProducts = [];
      let updateCart = [];
      for (const iterator of val) {
        for (const item of this.items) {
          if (iterator.id === item.id) {
            updateCart.push({
              ...item,
              amountChanged: iterator.amountChanged,
              maxAmount: iterator.maxAmount,
            });
          }
        }
      }
      this.selectedProducts = updateCart;
    },
  },
  watch: {
    checkoutCart: function (val) {
      this.updateCart(val);
    },
  },
  mounted() {
    this.cartId = localStorage.getItem("cartId");
    this.cart = localStorage.getItem("cart")
      ? localStorage.getItem("cart")
      : [];
    this.selectedProducts = this.items;
    this.removeItem();
    this.addToCart();
  },

  computed: {
    // listCart() {
    //   const startIndex = (this.currentPagecart - 1) * this.perPagecart;
    //   const endIndex = startIndex + this.perPagecart;
    //   const myItems = this.items;
    //   return this.items.slice(startIndex, endIndex);
    // },
  },
};
</script>

<style lang="scss">
.card_details_product {
  display: flex;
  width: 100%;
  overflow: hidden !important;
  margin-bottom: 12px;
  border-radius: 16px !important;
  box-shadow: none !important;
  padding: 25px 35px;
}

.img_box_details_product {
  width: 100%;
  height: 150px;
  cursor: pointer;
  @media only screen and (max-width: 1366px) {
    width: 100%;
  }
  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
  @media only screen and (max-width: 768px) {
    height: 232px;
    width: 80%;
  }
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    object-fit: contain;
  }
}

.footer_card_information {
  display: flex;
}

.card_counter_producet {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.box_mobile_product-r {
  display: flex;
  flex-wrap: wrap;
}

.box_mobile_product-l {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: flex-end !important;
  width: 100%;
}

.btn_basket_cart {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 2px solid #7c4dff;
  border-radius: 50%;
  overflow: hidden;
}

.item_content_box_info_product {
  display: flex;
}

.text_content_details_product {
  display: flex;
  align-items: center;
  h5 {
    font-size: 14px;
    margin: 0;
    @media only screen and (max-width: 768px) {
      font-size: 12px;
    }
  }
}

.type_price_product {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.price_box_details_product {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  h5 {
    font-size: 16px;
    margin: 0 3px;
  }
}

.text-stock {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  @media only screen and (max-width: 800px) {
    justify-content: center;
  }
  h6 {
    font-size: 14px;
    margin: 0;
    @media only screen and (max-width: 1366px) {
      font-size: 12px;
    }
    @media only screen and (max-width: 600px) {
      font-size: 14px;
    }
  }
}

.items_mobile_product-r {
  display: flex;
  flex-direction: column;
}

.line_discount_price {
  display: flex;
  flex-direction: column;
}

.box_discount_cart {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  overflow: hidden;
  background: #d50000;
  color: white;

  span {
    font-size: 16px;
    font-weight: 500;
  }
}

@media only screen and (min-width: 1280px) {
  .box_discount_cart {
    width: 35px;
    height: 35px;

    span {
      font-size: 15px;
    }
  }
}

@media only screen and (max-width: 1024px) {
  .card_details_product {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    height: auto;
  }

  .price_box_details_product {
    display: flex;
    align-items: center;
    h5 {
      font-size: 14px;
    }
  }

  .box_mobile_product-l {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    align-self: flex-start !important;
  }

  .type_price_product {
    margin-left: 10px;
    margin-right: 0 !important;
    padding-right: 0 !important;
  }

  .type_price_product,
  .card_counter_producet {
    align-self: center !important;
  }
}

@media only screen and (max-width: 600px) {
  .box_mobile_product-r,
  .footer_card_information {
    display: flex;
    flex-direction: column;
  }

  .text_content_details_product {
    justify-content: center;
  }

  .box_mobile_product-l {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
}
</style>
